import UserRole from "./UserRole";

export default UserRole;
